import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { ApiService } from "./api.service";
import { BehaviorSubject, filter, shareReplay, switchMap } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  http = inject(HttpClient);
  apiService = inject(ApiService);
  // Holds the latest request params
  private statementParams$ = new BehaviorSubject<any | null>(null);

  // Public observable of the account statement
  readonly statement$ = this.statementParams$.pipe(
    filter((params) => !!params), // ignore initial null
    switchMap((params) => this.fetchStatement(params)), // cancels previous requests
    shareReplay(1), // keeps the latest result for late subscribers
  );

  constructor() {}

  // Triggers a new request (automatically cancels previous one)
  fetchAccountStatement(params: any) {
    this.statementParams$.next(params);
  }

  fetchStatement(body: any) {
    return this.http.post(`${environment.sURL}${environment.endpoints.balanceStatement}`, body, { headers: this.apiService.getHeaders() });
  }

  fetchProfitAndLoss(params?: any) {
    return this.http.get(`${environment.sURL}${environment.endpoints.profitAndLoss}`);
  }

  fetchProfitAndLossDetails(params?: any) {
    return this.http.get(`${environment.sURL}${environment.endpoints.profitAndLossDetail}/${params.MARKET_ID}`);
  }
}
